import { render, staticRenderFns } from "./InviteMobile.vue?vue&type=template&id=87112ca4&scoped=true"
import script from "./InviteMobile.vue?vue&type=script&lang=js"
export * from "./InviteMobile.vue?vue&type=script&lang=js"
import style0 from "./InviteMobile.vue?vue&type=style&index=0&id=87112ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87112ca4",
  null
  
)

export default component.exports